import styled from 'styled-components';

export const Container = styled.div`
  position: relative;

  width: 38%;
  padding: 24px;

  box-shadow: 0px 4px 16px -4px rgba(145, 158, 171, 0.12);
  border-radius: 16px;
`;

export const Table = styled.table`
  width: 100%;

  tr {
    display: grid;
    grid-template-columns: 20% 48% 32%;
  }

  th,
  td {
    padding: 16px;
  }

  td {
    border-bottom: 1px solid #e2e5e8;
  }
`;

export const TableHeaderRow = styled.tr`
  background: rgba(145, 158, 171, 0.16);
  border-radius: 8px;

  th:first-child {
    border-top-left-radius: 10px;
  }
  th:last-child {
    border-top-right-radius: 10px;
  }
  th:first-child {
    border-bottom-left-radius: 10px;
  }
  th:last-child {
    border-bottom-right-radius: 10px;
  }
`;

export const TableRow = styled.tr``;

export const LoadingContainer = styled.div`
  position: absolute;
  top: 0;

  width: calc(100% - 48px);
  height: 100%;

  z-index: 999;

  background: rgba(255, 255, 255, 0.8);

  display: flex;
  justify-content: center;
  align-items: center;
`;

export const NoDataContainer = styled.div`
  height: 100%;

  display: flex;
  justify-content: center;
  align-items: center;

  h3 {
    font-size: 18px;
    color: #aaa;
  }
`;
